export const createMatch = /* GraphQL */ `
  mutation CreateMatch(
    $input: CreateMatchInput!
    $documentTextTypeFilter: ModelStringKeyConditionInput
  ) {
    # Keep matches fields in sync with GetNextJobOpportunityMatches query
    createMatch(input: $input) {
      id
      applicationId
      availableStartDate
      createdAt
      creator
      customerRate {
        value
      }
      freelancerPitch
      freelancerPitchPrefill
      isAccepted
      jobOpportunityId
      matchAgent
      metadata
      notesCount
      rate {
        value
      }
      rating
      reasonsForRating
      resumeLocation
      status
      subStatus
      userId
      updater
      matcher
      updatedAt
      user {
        assessments {
          id
          assessmentCompleted
          codeScore
          createdAt
          finalScore
          multipleChoiceScore
          pdfResultLocation
          resultDetails {
            id
            analysis {
              key
              explanation
              score
              summary
              name
            }
            integrityReport {
              explanation
              risk
            }
            interviewId
            ropesUserId
            score
            source
            testId
          }
          interviewId
          reportLink
          reportLinkExpiresAt
          source
          status
          testName
          timeTaken
          updatedAt
        }
        TKSkills {
          id
          category
          experience
          experienceYears
          languageIsoCode
          name
        }
        bio
        bullhornStatus
        createdAt
        lastActivityDate
        careers {
          id
          companyName
          companyDomain
          description
          endDate
          format
          locationType
          skills {
            experience
            name
          }
          stack
          startDate
          title
          TKSkills {
            id
            category
            experience
            experienceYears
            languageIsoCode
            name
          }
        }
        documentsText(type: $documentTextTypeFilter) {
          items {
            id
            paragraphs
            type
            userId
          }
        }
        educationRecords {
          id
          degreeType
          degreeName
          description
          endDate
          fieldOfStudy
          school
          startDate
        }
        certifications {
          id
          title
          issuingOrganization
          issuingOrganizationDomain
          issueDate
          expirationDate
          credentialId
          credentialUrl
          TKSkills {
            id
            category
            experience
            experienceYears
            languageIsoCode
            name
          }
        }
        email
        headshotKey
        username
        id
        talentSource
        additionalMarkup
        availability
        noticePeriod
        family_name
        given_name
        identity_username
        isUnclaimed
        location {
          cityName
          countryCode
          countryName
          stateName
        }
        profileCompletion
        metadata
        ratePerHour {
          currency
          value
        }
        salary {
          currency
          value
        }
        phone {
          number
          whatsAppAllowed
        }
        placements {
          id
          actualEndDate
          endDate
        }
        projectsCaseStudies {
          id
          client
          description
          endDate
          workType
          link
          stack
          startDate
          title
        }
        referrerCode
        resumeWorkHistory {
          id
          TKSkills {
            id
            category
            experience
            experienceYears
            languageIsoCode
            name
          }
          companyName
          companyDomain
          description
          endDate
          format
          locationType
          stack
          startDate
          title
        }
        systemModTimestamp
        knownLanguages {
          level
          language
        }
        placements {
          id
          actualEndDate
          createdAt
          companyName
          endDate
          jobOpportunityId
          startDate
          updatedAt
        }
        socialLinks {
          type
          value
        }
        status
        otherLinks {
          description
          name
          type
          value
          visibility
        }
        resumeLocation
        torcQualityStats
        workAuthorizations
      }
      userId
    }
  }
`;
export const updateMatch = /* GraphQL */ `
  mutation UpdateMatch($input: UpdateMatchInput!) {
    updateMatch(input: $input) {
      applicationId
      jobOpportunityId
      rejectionByCustomer
      isAccepted
      resumeLocation
      status
      subStatus
      rate {
        value
      }
      customerRate {
        value
      }
    }
  }
`;
export const deleteMatch = /* GraphQL */ `
  mutation DeleteMatch($input: DeleteMatchInput!) {
    deleteMatch(input: $input) {
      applicationId
      jobOpportunityId
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      metadata
      headshotKey
      family_name
      given_name
      tagline
      bio
      phone {
        number
        whatsAppAllowed
      }
      location {
        cityName
        countryCode
        countryId
        countryName
        latitude
        locationId
        longitude
        stateCode
        stateId
        stateName
        wikiDataId
      }
      ratePerHour {
        currency
        value
      }
      salary {
        currency
        value
      }
      otherLinks {
        description
        name
        type
        value
        visibility
      }
      resumeLocation
      careers {
        id
        companyName
        companyDomain
        title
        TKSkills {
          id
          category
          experience
          experienceYears
          languageIsoCode
          name
        }
      }
      certifications {
        id
        title
        issuingOrganization
        issuingOrganizationDomain
        issueDate
        expirationDate
        credentialId
        credentialUrl
        TKSkills {
          id
          category
          experience
          experienceYears
          languageIsoCode
          name
        }
      }
      projectsCaseStudies {
        id
        title
        TKSkills {
          id
          category
          experience
          experienceYears
          languageIsoCode
          name
        }
      }
    }
  }
`;
export const createNote = /* GraphQL */ `
  mutation CreateNote($input: CreateNoteInput!) {
    createNote(input: $input) {
      applicationId
      content
      isPublic
      jobOpportunityId
      userId
    }
  }
`;
export const deleteNote = /* GraphQL */ `
  mutation DeleteNote(
    $input: DeleteNoteInput!
    $condition: ModelNoteConditionInput
  ) {
    deleteNote(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateJobOpportunity = /* GraphQL */ `
  mutation UpdateJobOpportunity($input: UpdateJobOpportunityInput!) {
    updateJobOpportunity(input: $input) {
      id
      torcOwner {
        id
        username
      }
    }
  }
`;

export const createSharedAssessment = /* GraphQL */ `
  mutation CreateSharedAssessment($input: createSharedAssessmentInput!) {
    createSharedAssessment(input: $input) {
      message
    }
  }
`;

export const gtp = /* GraphQL */ `
  mutation Gtp($input: GtpInput!) {
    gtp(input: $input) {
      success
      message
    }
  }
`;

export const updateJobLongList = /* GraphQL */ `
  mutation UpdateJobLongList($input: UpdateJobLongListInput!) {
    updateJobLongList(input: $input) {
      jobOpportunityId
      userId
      convertedToMatch
    }
  }
`;
